import styled from 'styled-components';
import { TextBase } from './TextBase';

export const TextWrapper = styled(TextBase).attrs({ as: 'span' })``;
